import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from 'providers/auth-provider'
import { Helmet } from 'react-helmet-async'

import './utils/i18n'
import './utils/sentry'
import 'global.css'
import { ErrorBoundary } from '@sentry/react'
import { helmet } from 'helmet'
import { router } from './router'
import { queryClient } from './query-client'
import { queryCacheService } from './features/query-cache-service'

if (
  window.location.origin.includes('localhost') ||
  window.location.origin.includes('192.168') ||
  window.location.origin.includes('.trycloudflare.com')
) {
  console.log('localhost detected, window.isDevMode is enabled')
  window.isDevMode = true
}

const App: React.FC = () => {
  useEffect((): VoidFunction => {
    return queryCacheService.subscribe()
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ErrorBoundary
          // eslint-disable-next-line react/no-unescaped-entities
          fallback={<p>Something went wrong. We're already working on it</p>}
        >
          <Helmet helmetData={helmet}>
            <title>Vacancy Interview</title>
          </Helmet>
          <RouterProvider router={router} />
        </ErrorBoundary>
      </AuthProvider>
      {/* <CookieConfirmationPopup /> */}
    </QueryClientProvider>
  )
}

const rootElement = document.getElementById('root')!

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)

  root.render(
    // <StrictMode>
    <App />
    // </StrictMode>
  )

  // inspect({
  //   /**
  //    * Explicitly define that we will
  //    * catch only messages where Scope is undefined
  //    */
  //   // scope: undefined,
  //   trace: true,
  //   scope: undefined,
  //   fn: (m) => {
  //     const name = `${m.kind} ${m.name}`
  //     const error = new Error(`${name} is not bound to scope`)
  //
  //     console.log(name, error)
  //   }
  // })

  // allSettled(startPermissionsService, { scope })
  // allSettled(startDevicesService, { scope })
}
